<template>
  <standard-layout v-if="product" :header="product.name">
    <template v-slot:main>
      <modal class="position-absolute shadow" title="Detail-Editor"
             v-if="detailEditorOpen"
             @close="detailEditorOpen = false">
        <template v-slot:body>
          <product-detail-editor :value="product.detailId" @select="selectDetail($event)" title="Detail Editor"/>
        </template>
        <template v-slot:footer>
          <button type="button" class="btn btn-secondary" @click="displayedDetail = null">Wählen</button>
        </template>
      </modal>
      <div class="row">
        <div class="col-12 col-md-6 form-group">
          <label for="idInput">Name</label>
          <input id="idInput"
                 class="form-control"
                 type="text"
                 v-model="product.name"/>
        </div>
        <div class="col-12 col-md-6 form-group">
          <label for="categoryInput">Kategorie</label>
          <select id="categoryInput"
                  class="form-control custom-select"
                  v-model="product.category">
            <option v-for="cat in categories" :key="cat.name" :value="cat.name">{{ cat.displayName }}</option>
          </select>
        </div>
        <div class="col-12 form-group">
          <label for="descriptionInput">Kurzbeschreibung</label>
          <input id="descriptionInput"
                 type="text"
                 class="form-control"
                 v-model="product.description"/>
        </div>
        <div class="col-12 col-md-6 form-group form-inline">
          <label for="detailInput">Detailbeschreibung</label>
          <select id="detailInput"
                  class="form-control custom-select ml-1"
                  v-model="product.detailId">
            <option :value="null" :selected="!product.detailId">-- keine --</option>
            <option v-for="detail in details"
                    :key="detail.id"
                    :value="detail.id"
                    :selected="product.detailId === detail.id">{{ detail.name }}
            </option>
          </select>
          <button class="btn btn-primary btn-sm ml-1" @click="detailEditorOpen = true">Neu</button>
        </div>
        <div class="col-12 col-md-6 form-control overflow-auto p-1"
             style="min-height: 6rem!important; max-height: 6rem;">
          <span v-if="product.detailId > 0"
                v-html="detailContent"
                class="text-muted small"/>
        </div>
        <div class="col-12 form-group">
          <label for="imageInput">Bild</label>
          <div class="d-flex">
            <cld-image
                id="imageInput"
                v-if="product.imageId"
                :public-id="product.imageId"
                size="150"
                class="img-fluid"/>
            <div class="my-auto ml-3">
              <button class="btn btn-primary btn-sm"
                      @click="openUploadModal">
                Hochladen / Ändern
              </button>
            </div>
          </div>
        </div>
        <div v-if="attendeeProduct"
             class="col-12 col-md-6 form-group">
          <label for="attendeeInput">Teilnehmer</label>
          <input id="attendeeInput"
                 class="form-control"
                 type="number"
                 v-model="product.attendees">
        </div>
        <div v-if="attendeeProduct"
             class="col-12 col-md-6 form-group">
          <label for="durationInput">Dauer (in h)</label>
          <input id="durationInput"
                 class="form-control"
                 type="number"
                 v-model="product.duration">
        </div>
        <div class="col-12 col-md-6 form-group">
          <label for="pricingTypeInput">Preismodell</label>
          <select id="pricingTypeInput"
                  class="form-control custom-select"
                  v-model="product.pricingType">
            <option v-for="pricingType in pricingTypes" :key="pricingType.name" :value="pricingType.name">
              {{ pricingType.displayName }}
            </option>
          </select>
        </div>
        <div v-if="product.category === 'VOU'"
             class="col-12 col-md-6">
          <label for="voucherProductForIdSelect">Gutschein für</label>
          <select id="voucherProductForIdSelect"
                  class="form-control custom-select"
                  v-model="product.voucherProductForId">
            <option v-for="product in reservationProducts"
                    :key="'sel_' + product.id"
                    :value="product.id">
              {{ product.name }}
            </option>
          </select>
        </div>
        <div v-if="product.category === 'PER'"
             class="col-12 col-md-6">
          <label>Zusätzliche Person für</label>
          <div class="form-inline"
               v-for="resProduct in reservationProductsWithAttendeeProductForCheck"
               :key="'ap4_' + resProduct.id">
            <input class="form-control custom-checkbox"
                   type="checkbox"
                   :checked="resProduct.attendeeProductFor"
                   @click="makeAttendeeProductFor(resProduct, $event.target.checked)"/>
            <span class="ml-2">{{ resProduct.name }}</span>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <label for="#articleField">Artikel</label>
          <div id="articleField">
            <div v-if="articles.length > 0">
              <div v-for="article in articles" :key="article.id">{{ article.id }}&nbsp;{{ article.product.name }}</div>
            </div>
            <button class="btn btn-danger btn-sm" @click="generateArticleForProduct"><span v-if="articles.length > 0">weiteren </span>Artikel
              generieren
            </button>
          </div>
        </div>
      </div>
      <div class="text-right">
        <button class="btn btn-primary"
                @click="save">
          Speichern
        </button>
      </div>
    </template>
  </standard-layout>
</template>
<script>
import StandardLayout from "@/layouts/StandardLayout";
import ProductDetailEditor from "@/components/ProductDetailEditor";
import Modal from "@/layouts/Modal";

export default {
  props: {
    productId: String
  },
  data() {
    return {
      product: null,
      categories: [],
      pricingTypes: [],
      details: [],
      reservationProducts: [],
      detailEditorOpen: false,
      articles: []
    }
  },
  computed: {
    attendeeProduct() {
      return ['RES'].indexOf(this.product?.category) >= 0
    },
    category() {
      return this.product?.category
    },
    detailContent() {
      return (this.details.filter(d => d.id === this.product?.detailId))[0]?.content
    },
    reservationProductsWithAttendeeProductForCheck() {
      return this.reservationProducts.map(r => {
        const isAttendeeProductForThis = this.product?.attendeeProductFor.map(p => p.id).indexOf(r.id) >= 0
        return {...r, attendeeProductFor: isAttendeeProductForThis}
      })
    }
  },
  methods: {
    init() {
      this.$api.get('/product-metadata')
          .then(res => {
            this.categories = res.data.categories
            this.pricingTypes = res.data.pricingTypes
          })
      if (this.productId) {
        this.$api.get(`/products/${this.productId}`)
            .then(res => this.product = res.data)
            .catch(err => this.handleError(err))
      } else {
        this.product = {id: this.productId, name: 'Neues Produkt'}
      }
      this.$api.get(`/product-details`)
          .then((res) => this.details = res.data)
          .catch(err => this.handleError(err))
      this.$api.get(`/products`, {
        params: {
          category: 'RES'
        }
      }).then((res) => this.reservationProducts = res.data)
          .catch(err => this.handleError(err))
    },
    async selectDetail(detailId) {
      console.log('detailId: ' + detailId)
      await this.$api.get(`/product-details`)
          .then((res) => this.details = res.data)
          .catch(err => this.handleError(err))
      this.product.detailId = detailId
    },
    openUploadModal() {
      window.cloudinary.openUploadWidget({
        cloud_name: 'spaboot',
        upload_preset: process.env.VUE_APP_SPABOOT_CLOUDINARY_PRODUCT_IMAGE_UPLOAD_PRESET
      }, (error, result) => {
        if (!error && result && result.event === "success") {
          this.url = result.info.url;
          this.product.imageId = result.info.public_id;
        }
      }).open()
    },
    makeAttendeeProductFor(productThisIsAttendeeProductFor, on) {
      if (on)
        this.product.attendeeProductFor.push({
          id: productThisIsAttendeeProductFor.id,
          name: productThisIsAttendeeProductFor.name
        })
      else {
        const idx = this.product.attendeeProductFor.map(p => p.id).indexOf(productThisIsAttendeeProductFor.id)
        if (idx >= 0)
          this.product.attendeeProductFor.splice(idx, 1);
      }
    },
    async getArticle(articleId) {
      return await this.$api.get(`/articles/${articleId}`).then(res => res.data)
    },
    loadArticlesForProduct() {
      console.log('loading articles for product')
      this.$api.get('/articles', {
        params: {
          channel: 'web',
          product: this.product.id
        }
      }).then((res) => {
        this.articles = res.data;
      });
    },
    async generateArticleForProduct() {
      if (!this.product.id)
        this.showWarning("Speichere zunächst das Produkt")
      else {
        await this.$api.put(`/articles`, [], {
          params: {
            action: 'createForProduct',
            product: this.product.id
          }
        }).catch(err => this.handleError(err))
        this.loadArticlesForProduct()
      }
    }
    ,
    save() {
      const method = this.product.id ? this.$api.put : this.$api.post
      let url = `/products`
      if (this.product.id)
        url += `/${this.product.id}`
      method(url, this.product)
          .then(res => {
            this.product = res.data
            if (this.product.id !== this.productId)
              this.$router.push({name: 'editProduct', params: {productId: this.product.id}})
            this.showInfo('Deine Änderungen wurden gespeichert.')
          }).catch(err => this.handleError(err))
    }
  },
  watch: {
    product(newVal) {
      if (newVal?.id)
        this.loadArticlesForProduct()
    }
  },
  created() {
    this.init()
  }
  ,
  components: {
    Modal,
    ProductDetailEditor,
    StandardLayout
  }
}
</script>

